<template>
  <div class="bg-white">
    <Head>
      <Title>{{ $messages('locations.meta.title') }}</Title>
      <Meta name="description" hid="description" :content="$t('locations.meta.description')" />
    </Head>

    <BlocksLocationsHero
      :title="$messages('locations.locations_hero.title')"
      :body="$messages('locations.locations_hero.body')"
      :breadcrumbs="breadcrumbs"
      :image-url="isSpanish ? 'https://majority.imgix.net/web-assets/no-ssn/nossn-4.jpg' : 'https://majority.imgix.net/web-assets/locations/MAJORITY-HOUSTON-118.jpg'"
    />
    <LocationsList :locations="locations" />
    <BlocksLocationsHero
      :title="$messages('locations.locations_footer_hero.title')"
      :body="$messages('locations.locations_footer_hero.body')"
      image-url="https://majority.imgix.net/web-assets/locations/location-wallet.webp"
      small-text
    />
  </div>
</template>

<script>
import locationsData from '@/assets/docs/locations.json'

export default {
  name: 'Locations',
  layout: 'default',
  data () {
    return {
      breadcrumbs: [
        {
          title: this.$messages('label.home'),
          to: this.$mRouter.getLocalRoute({ name: 'index' })
        },
        {
          title: this.$messages('page_labels.locations')
        }
      ],
      locations: locationsData.locations
    }
  },
  computed: {
    isSpanish () {
      return this.$i18n.locale === 'es'
    }
  }
}
</script>
